(() => {
  const DURATION_MS = 20 * 1000;
  const STATE_KEY = 'autoglas-ribbon-banner-state-v1';
  const CLOSED_ELEMENTS_KEY = 'theme-closed-elements';

  const getLocalDate = () => {
    const now = new Date();

    return [
      now.getFullYear(),
      String(now.getMonth() + 1).padStart(2, '0'),
      String(now.getDate()).padStart(2, '0')
    ].join('-');
  };

  const readStorage = (key, fallback) => {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch {
      return fallback;
    }
  };

  const writeStorage = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Do nothing if browser storage is unavailable.
    }
  };

  const ribbon = document.querySelector('.ribbon-banner');

  if (!ribbon) {
    return;
  }

  const closableElement = ribbon.closest('closable-element');
  const target = closableElement || ribbon;
  const shopifySection = ribbon.closest('[id^="shopify-section-"]');

  const legacyIds = new Set(
    [
      ribbon.id,
      shopifySection ? shopifySection.id : '',
      ribbon.id ? `shopify-section-${ribbon.id}` : ''
    ].filter(Boolean)
  );

  const clearLegacyCloseState = () => {
    const closedElements = readStorage(CLOSED_ELEMENTS_KEY, []);

    if (!Array.isArray(closedElements)) {
      return;
    }

    const remainingElements = closedElements.filter(
      (id) => !legacyIds.has(id)
    );

    writeStorage(CLOSED_ELEMENTS_KEY, remainingElements);
  };

  const hideRibbon = () => {
    target.style.display = 'none';
    target.setAttribute('aria-hidden', 'true');
  };

  const showRibbon = () => {
    target.style.removeProperty('display');
    target.style.removeProperty('max-height');
    target.removeAttribute('aria-hidden');
  };
  if (window.Shopify && window.Shopify.designMode) {
  clearLegacyCloseState();
  showRibbon();
  return;
}

  const today = getLocalDate();
  const currentTime = Date.now();

  let state = readStorage(STATE_KEY, null);

  if (!state || state.date !== today) {
    state = {
      date: today,
      startedAt: currentTime,
      closed: false
    };

    writeStorage(STATE_KEY, state);
    clearLegacyCloseState();
  }

  const endTime = state.startedAt + DURATION_MS;

  if (state.closed || currentTime >= endTime) {
    hideRibbon();
    return;
  }

  showRibbon();

  const remainingTime = endTime - currentTime;

  const timer = window.setTimeout(() => {
    hideRibbon();
  }, remainingTime);

const closeButton = target.querySelector(
  '[data-close-button], .js-close-button'
);

  if (closeButton) {
    closeButton.addEventListener(
      'click',
      () => {
        window.clearTimeout(timer);

        state.closed = true;
        writeStorage(STATE_KEY, state);

        hideRibbon();
      },
      { once: true }
    );
  }
})();
